<template>
  <div id="refund-modal-preview" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="p-5 text-center">
            <InfoIcon class="w-16 h-16 text-theme-12 mx-auto mt-3" />
            <div class="text-3xl mt-5">
              คุณแน่ใจ
            </div>
            <div class="text-gray-600 mt-2">
              ต้องการคืนเงินเต็มจำนวนรายการนี้ ใช่ หรือ ไม่?
            </div>
            <div class="mt-4 text-left">
              <label for="" class="form-label text-lg">GL Date:</label>
              <div class="grid grid-cols-1 mb-2 lg:mb-2">
                <div class="p-fluid p-grid">
                  <div class="p-field p-field-sm">
                    <Calendar
                      :baseZIndex="10000"
                      placeholder="2022-01-01"
                      inputStyle="padding:0.5rem 0.75rem;"
                      v-model="date"
                      dateFormat="yy-mm-dd"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
            >
              ไม่
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-warning w-24"
              @click="refund()"
            >
              ใช่
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
// import { useRouter } from 'vue-router'
import { api } from '../utils/api'
import alert from '../helpers/alert'
import helpers from '../helpers'

export default defineComponent({
  name: 'modalCancelRemark',
  props: {
    module: {
      type: String,
      required: true
    },
    docType: {
      type: String,
      required: true
    },
    docId: {
      type: [Number, String]
    },
    redirectComplete: {
      type: String,
      required: true
    }
  },
  setup(props) {
    // const router = useRouter()
    const date = ref()
    const { dateFormat } = helpers
    const refund = async () => {
      await api
        .post(`/${props.module}/${props.docType}/fullRefund`, {
          ca_id: props.docId,
          gl_date: dateFormat(date.value)
        })
        .then(res => {
          if (res.code == 200) {
            alert.success()
            // router.push({ name: props.redirectComplete })
          } else {
            if (res.message == '') {
              alert.validatorShow(res.validator)
            } else {
              alert.error(res.message)
            }
          }
        })
        .catch(e => alert.error(e.message))
    }
    return {
      refund,
      date
    }
  }
})
</script>

<style scoped></style>
